module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"next":"Next","cancel":"Cancel","vacancy-head-text":"Jobs on the website Rabota.ru","vacancy-not":"You have no open jobs on rabota.ru"}}')
  delete Component.options._Ctor
}
